import { render, staticRenderFns } from "./Snapshot.vue?vue&type=template&id=086505be"
import script from "./Snapshot.vue?vue&type=script&lang=js"
export * from "./Snapshot.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports